<script>
export default {
  install(Vue) {
    /**
     * Bootstrap is using .98 for max widths based on their experience with different browsers. For example 575.98
     * as XS max width. That's a reduction of 0.02 from the SM min width of 576 and that's value of this variable.
     */
    const maxWidthReduction = 0.02;

    const smMinWidth = 576;
    const mdMinWidth = 768;
    const lgMinWidth = 992;
    const xlMinWidth = 1200;
    const xxlMinWidth = 1400;

    const xs = {
      active: false,
      designation: "xs",
      minWidth: null,
      maxWidth: smMinWidth - maxWidthReduction
    };
    const sm = {
      active: false,
      designation: "sm",
      minWidth: smMinWidth,
      maxWidth: mdMinWidth - maxWidthReduction
    };
    const md = {
      active: false,
      designation: "md",
      minWidth: mdMinWidth,
      maxWidth: lgMinWidth - maxWidthReduction
    };
    const lg = {
      active: false,
      designation: "lg",
      minWidth: lgMinWidth,
      maxWidth: xlMinWidth - maxWidthReduction
    };
    const xl = {
      active: false,
      designation: "xl",
      minWidth: xlMinWidth,
      maxWidth: xxlMinWidth - maxWidthReduction
    };
    const xxl = {
      active: false,
      designation: "xxl",
      minWidth: xxlMinWidth,
      maxWidth: null
    };

    // Add a global mixin to include media query functionality
    Vue.mixin({
      data() {
        return {
          mediaSizes: {
            xs: xs,
            sm: sm,
            md: md,
            lg: lg,
            xl: xl,
            xxl: xxl,
            order: [xs, sm, md, lg, xl, xxl],
            maxWidthReduction: maxWidthReduction
          }
        };
      },
      methods: {
        $registerMediaQuery(mediaSize, query) {
          const mediaQueryList = window.matchMedia(query);

          const updateMatches = () => {
            mediaSize.active = mediaQueryList.matches;
          };

          updateMatches(); // Initialize the value

          // Store the event listener
          const listener = () => updateMatches();
          if (mediaQueryList.addEventListener) {
            mediaQueryList.addEventListener("change", listener)
          } else {
            // Safari 13 and below
            mediaQueryList.addListener(listener)
          }

          // Save the cleanup function
          if (!this._mediaQueryListeners) {
            this._mediaQueryListeners = {};
          }
          this._mediaQueryListeners[mediaSize.designation] = () => {
            if (mediaQueryList.removeEventListener) {
              mediaQueryList.removeEventListener("change", listener)
            } else {
              // Safari 13 and below
              mediaQueryList.removeListener(listener)
            }
          }
        },
        $unregisterMediaQuery(designation) {
          if (this._mediaQueryListeners && this._mediaQueryListeners[designation]) {
            this._mediaQueryListeners[designation](); // Remove the event listener
            delete this._mediaQueryListeners[designation];
          }
        },
      },
      mounted() {
        this.$registerMediaQuery(this.mediaSizes.xs, `(max-width: ${xs.maxWidth}px)`);
        this.$registerMediaQuery(this.mediaSizes.sm, `(min-width: ${sm.minWidth}px) and (max-width: ${sm.maxWidth}px)`);
        this.$registerMediaQuery(this.mediaSizes.md, `(min-width: ${md.minWidth}px) and (max-width: ${md.maxWidth}px)`);
        this.$registerMediaQuery(this.mediaSizes.lg, `(min-width: ${lg.minWidth}px) and (max-width: ${lg.maxWidth}px)`);
        this.$registerMediaQuery(this.mediaSizes.xl, `(min-width: ${xl.minWidth}px) and (max-width: ${xl.maxWidth}px)`);
        this.$registerMediaQuery(this.mediaSizes.xxl, `(min-width: ${xxl.minWidth}px)`);
      },
      beforeDestroy() {
        // Cleanup all registered media query listeners
        if (this._mediaQueryListeners) {
          Object.values(this._mediaQueryListeners).forEach((cleanup) =>
              cleanup()
          );
          this._mediaQueryListeners = null;
        }
      },
    });
  }
}
</script>
